











import Vue from 'vue'
import './WidgetThumbnail.scss'

/*
  We cannot provide a dynamic path to the img src instead of conditional chaining img elements,
  since webpack won't pick up the images or update the relative path to match the actual file.
  Unless we make a folder of static assets that we can reference with absolute paths,
  we probably won't be able to accomplish the single-line refactoring solution.
  This component is the next best approach, to at least prevent duplicate code.
*/
export default Vue.extend({
  name: 'WidgetThumbnail',
  props: {
    widgetUrl: {
      type: String,
      default: ''
    },
  },
  computed: {
    url (): string {
      return this.widgetUrl.toLowerCase() //Check as lowercase
    },
  }
})
